"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectSelector = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translate_1 = require("utils/translate");
var Icon_1 = require("components/Icon");
var Types = require("types");
require("./styles.scss");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)() || 'en';
    return {
        currentProject: state.project.currentProject,
        projects: state.projects.projects,
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
function getRecents(projects, currentProject) {
    return projects
        .filter(function (x) { return x.id !== currentProject.id; })
        .sort(function (a, b) {
        if (a.visitedAt === null && b.visitedAt === null) {
            return b.projectId - a.projectId;
        }
        return (b.visitedAt || 0) - (a.visitedAt || 0);
    })
        .slice(0, 5);
}
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'toggleDropdown', false), (0, recompose_1.withState)('recents', 'setRecents', []), (0, react_redux_1.connect)(exports.mapStateToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.currentProject.status === 'FETCHED') {
            this.props.setRecents(getRecents(this.props.projects, this.props.currentProject.project));
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.currentProject.status === 'FETCHED') {
            if (this.props.projects !== prevProps.projects) {
                this.props.setRecents(getRecents(this.props.projects, this.props.currentProject.project));
            }
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.isOpen !== nextProps.isOpen ||
            this.props.currentProject !== nextProps.currentProject ||
            this.props.projects !== nextProps.projects ||
            this.props.recents !== nextProps.recents ||
            this.props.selectedLanguage !== nextProps.selectedLanguage) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.ProjectSelector = enhance(function (props) { return (React.createElement(sok_ui_1.Dropdown2, { className: 'project-selector d-none d-tablet-block', isOpen: props.isOpen, onChange: function () { return props.toggleDropdown(!props.isOpen); } },
    React.createElement(sok_ui_1.Button, { color: "dark-gray", border: "pink", className: "full-width text-left responsive", size: 'large', text: props.currentProject.status === 'FETCHED'
            ? props.currentProject.project.name
            : '', icon: React.createElement(Icon_1.Icon, { key: "icon", className: "fa-building" }), iconRight: React.createElement(Icon_1.Icon, { key: "right-icon", className: "fa-chevron-down" }) }),
    React.createElement(sok_ui_1.Dropdown2Menu, null,
        React.createElement(sok_ui_1.Dropdown2MenuItem, { disabled: true }, (0, translation_1.getLocalization)('leftnavigation/project/recents')),
        props.recents.map(function (project, key) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "".concat(key, "-").concat(project.id), onClick: function () { return props.toggleDropdown(!props.isOpen); } },
            React.createElement("a", { onClick: function () {
                    return props.navigateToProject(props.selectedLanguage, project);
                } }, project.name))); })))); });
